import { render, staticRenderFns } from "./VDeleteBlocoDialog.vue?vue&type=template&id=42e66e1c"
import script from "./VDeleteBlocoDialog.vue?vue&type=script&lang=js"
export * from "./VDeleteBlocoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports